import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

export const GET_PROJECT_DOCUMENTS = gql`
  query ProjectDocuments($projectId: ID!) {
    projectDocuments(projectId: $projectId) {
      ...ProjectDocument
    }
  }
  ${fragments.projectDocument}
`

export const GET_DOCUMENT_UPLOAD_URL = gql`
  mutation GetDocumentUploadURL($userId: String!, $projectId: ID!, $filename: String!) {
    getDocumentUploadURL(userId: $userId, projectId: $projectId, filename: $filename)
  }
`

export const GET_DOCUMENT_ACCESS_URL = gql`
  mutation GetDocumentAccessURL($projectId: ID!, $filename: String!) {
    getDocumentAccessURL(projectId: $projectId, filename: $filename)
  }
`

export const ADD_DOCUMENT = gql`
  mutation AddDocument($userId: String!, $projectId: ID!, $filename: String!, $title: String!) {
    addDocument(userId: $userId, projectId: $projectId, filename: $filename, title: $title) {
      ...ProjectDocument
    }
  }
  ${fragments.projectDocument}
`

export const EDIT_DOCUMENT = gql`
  mutation EditDocument($projectId: ID!, $filename: String!, $title: String!) {
    editDocument(projectId: $projectId, filename: $filename, title: $title) {
      ...ProjectDocument
    }
  }
  ${fragments.projectDocument}
`

export const DELETE_DOCUMENT = gql`
  mutation DeleteDocument($projectId: ID!, $filename: String!) {
    deleteDocument(projectId: $projectId, filename: $filename) {
      projectId
      blobName
    }
  }
`

export default {
  addRemote: ADD_DOCUMENT,
  saveRemote: EDIT_DOCUMENT,
  deleteRemote: DELETE_DOCUMENT,
  saveOp: 'editDocument',
  addOp: 'addDocument',
  deleteOp: 'deleteDocument',
  getRemote: GET_PROJECT_DOCUMENTS,
}
